import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyName: "",
  companyLogo: "",
  disclaimerTermsCondition: "",
  companyAddress: "",
  companyPhoneNo: "",
  companyEmail: "",
};

export const reportInfoReducer = createSlice({
  name: "reportInfoReducer",
  initialState: initialState,
  reducers: {
    setReportInfo: (state, action) => {
      if (typeof action.payload === "object" && !Array.isArray(action.payload)) {
        Object.assign(state, action.payload); // ✅ Updates multiple fields
      }
    },
    updateReportInfo: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value; // ✅ Updating a single field dynamically
    },
    resetReportInfo: () => {
      return initialState;
    },
  },
});

export const {setReportInfo, updateReportInfo, resetReportInfo } = reportInfoReducer.actions;

export default reportInfoReducer.reducer;
